
import React, { Component } from "react";
import { connect } from "react-redux";
import '../../../../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css';
import '../../../../../../Assets/EnsembleStyles/ViewTenantDetails.css';
import { Button, Label, Input, FormGroup, Col } from 'reactstrap';
import { PutTenantDetailsAction } from '../../../../../../action/tenantAction';
import Currencies from '../../../../../../Resources/Currencies';
import ErrorGif from '../../../../../../Assets/images/Error.gif';

var ErrorMsg = 'Error: You left necessary fields blank or entered invalid values.';
class EditCompanyInformation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      TenantName: this.props.Tenant_Company_Information_response.tenantName,
      SelectedTenantName: this.props.Tenant_Company_Information_response.tenantName,
      Address: this.props.Tenant_Company_Information_response.address,
      ContactPhone: this.props.Tenant_Company_Information_response.contactPhone,
      InvoiceEmail: this.props.Tenant_Company_Information_response.invoiceEmail,
      CurrencyId: this.props.Tenant_Company_Information_response.currencyId,
      TenantID: this.props.Tenant_Company_Information_response.tenantId,
      create_error_msg: false,
      IsDuplicateTenantName:false,
      IsEmptyTenantName:false,
      IsInvalidEmail:false,
    };
    this.EditCompanyInformationPUT = this.EditCompanyInformationPUT.bind(this);
    this.returnToView = this.returnToView.bind(this);
  }


  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState({
        TenantName: nextProps.Tenant_Company_Information_response.tenantName,
        Address: nextProps.Tenant_Company_Information_response.address,
        ContactPhone: nextProps.Tenant_Company_Information_response.contactPhone,
        InvoiceEmail: nextProps.Tenant_Company_Information_response.invoiceEmail,
        CurrencyId: nextProps.Tenant_Company_Information_response.currencyId,
        TenantID: nextProps.Tenant_Company_Information_response.tenantId
      });
    }
  }
  componentDidMount() {
    this.refs.Billing_currency_select_input.options.selectedIndex = Number(this.state.CurrencyId);
  }

  EditCompanyInformationPUT(event) {
    event.preventDefault();
    this.setState({ create_error_msg: false, IsDuplicateTenantName:false, IsEmptyTenantName:false, IsInvalidEmail:false });
    ErrorMsg = 'Error: You left necessary fields blank or entered invalid values.';
    let IsValid = true;

    let Tenant_Name = this.state.TenantName;

    if(Tenant_Name === null || Tenant_Name === "" || Tenant_Name === undefined){
      IsValid = false;
      this.setState({create_error_msg: true, IsEmptyTenantName: true});
    }
        
    if (this.props.manageTenantsParams !== undefined && this.props.manageTenantsParams.TenantsList !== null) {
      let lstTenants = this.props.manageTenantsParams.TenantsList;
      if (lstTenants !== undefined && lstTenants.length > 0) {
        lstTenants = lstTenants.filter(function (item) {
          return Tenant_Name === item.tenantName
        });
        if (lstTenants !== null && lstTenants.length > 0) {
          if (lstTenants[0].tenantName !== this.state.SelectedTenantName) {
            ErrorMsg = 'Error: Duplicate Tenant Name.';
            IsValid = false;
            this.setState({ create_error_msg: true, IsDuplicateTenantName: true });
          }
        }
      }
    }

    let Email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var Billing_Email = this.state.InvoiceEmail.trim();
    if(Billing_Email !== null && Billing_Email !== ""){
      if(!Billing_Email.match(Email)){
          IsValid = false;
          this.setState({ create_error_msg: true, IsInvalidEmail: true });
      }  
  }

    if (IsValid) {
      let Currency_Id = this.refs.Billing_currency_select_input.options.selectedIndex;
      var editData = {
        "TenantName": this.state.TenantName,
        "Address": this.state.Address,
        "ContactPhone": this.state.ContactPhone,
        "InvoiceEmail": this.state.InvoiceEmail,
        "CurrencyId": Currency_Id
      };

      var tenant_Id = this.state.TenantID;
      this.props.PutTenantDetailsAction(editData, tenant_Id);

      this.returnToView();
    }
  }

  returnToView() {
    this.props.Display("value");
  }

  render(Tenant_Company_Information_response) {

    //Fetching and displaying list of currencies from Resources and appending it to the select option
    let CurrencyoptionsList = null;
    CurrencyoptionsList = Currencies.EntireCurrenciesList().map((el, index) => (<option id={index}>{el}</option>));

    let Create_Error_Message = null;
    (this.state.create_error_msg === true) ? Create_Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMsg}</p> : Create_Error_Message = "";

    return (
      <form onSubmit={this.EditCompanyInformationPUT}>
        <div className="Container">
          {Create_Error_Message}
          <div className="Customised_form_div">
            <legend className="form_sub_title">Tenant Company </legend>
            <div className="form_group ">
              <Label className="Custom_label">Company Name*</Label>
              <Input className="custom_input default-input" type="text" name="Company Name" ref="asdf" defaultValue={this.state.TenantName} onChange={e => this.setState({ TenantName: e.target.value })} maxLength="50"/>
              <span className="ErrorMark" hidden={!this.state.IsDuplicateTenantName && !this.state.IsEmptyTenantName}>!</span> 
            </div>

            <div className="form_group form_group_textarea">
              <Label className="Custom_label">Billing Address</Label>
              <textarea name="description" rows="4" className="custom_input default-input" defaultValue={this.state.Address} onChange={e => this.setState({ Address: e.target.value })} />
            </div>
            <div className="clear">&nbsp;</div>
            <div className="clear">&nbsp;</div>
            <div className="form_group">
              <Label className="Custom_label">Billing E-mail Address</Label>
              <Input className=" custom_input default-input" type="text" name="Company Name" defaultValue={this.state.InvoiceEmail} onChange={e => this.setState({ InvoiceEmail: e.target.value })} />
              <span className="ErrorMark" hidden={!this.state.IsInvalidEmail}>!</span> 
            </div>
            <div className="clear">&nbsp;</div>
            <div className="form_group form_group_textarea">
              <Label className="Custom_label">Contact Information</Label>
              <textarea name="description" rows="3" className="custom_input default-input" defaultValue={this.state.ContactPhone} onChange={e => this.setState({ ContactPhone: e.target.value })} />
            </div>
            <div className="clear">&nbsp;</div>

            <legend className="form_sub_title">Billing Options </legend>

            <div className="form_group" >
              <Label className="Custom_label_small_width">Billing Currency</Label>
              <select className="custom_input default-input select_small_width" ref="Billing_currency_select_input" >
                {CurrencyoptionsList}
              </select>
            </div>

            <FormGroup row className="btns_group">
              <Col sm={{ size: 10 }}>
                <Button className="btn-gray btn-md " id="return-to-view" onClick={this.returnToView}> Cancel  </Button>
                <Button type="submit" className="btn-success btn-md"  > Save</Button>
              </Col>
            </FormGroup>
          </div>
        </div>
      </form>


    );
  }
}

const mapStateToProps = state => {
  return {
    Tenant_Company_Information_response: state.ViewtenantsRootReducer.CompanyInformation,
    manageTenantsParams: state.tenantsRootReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    PutTenantDetailsAction: (CompanyInformationEditedData, TenantID) => dispatch(PutTenantDetailsAction(CompanyInformationEditedData, TenantID)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCompanyInformation);

